"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pinoGroupedLogHandlers = void 0;
var _types = require("../../types");
var _pinoApplicationInsightsLogHandler = require("./pinoApplicationInsightsLogHandler");
var _pinoConsoleLogHandler = require("./pinoConsoleLogHandler");
var _obj;
/** Collection of log handlers for each transport type */ var pinoGroupedLogHandlers = exports.pinoGroupedLogHandlers = (_obj = {}, _define_property(_obj, _types.LoggerTransportType.APPLICATION_INSIGHTS, _pinoApplicationInsightsLogHandler.pinoApplicationInsightsLogHandler), _define_property(_obj, _types.LoggerTransportType.CONSOLE, _pinoConsoleLogHandler.pinoConsoleLogHandler), _obj); //# sourceMappingURL=pinoGroupedLogHandlers.js.map
